import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";

import LoadingScreen from "components/shared/LoadingScreen";

import type { IAuthenticationGuardProps } from "../types";

const AuthenticationGuard: React.FC<IAuthenticationGuardProps> = ({ component }) => {
  const Component = withAuthenticationRequired(component, { onRedirecting: () => <LoadingScreen /> });

  return <Component />;
};

export default AuthenticationGuard;
